import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const LinkIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M8.3334 10.8333C8.69128 11.3118 9.14787 11.7077 9.6722 11.9941C10.1965 12.2806 10.7763 12.4509 11.3723 12.4936C11.9682 12.5363 12.5664 12.4503 13.1262 12.2415C13.686 12.0327 14.1943 11.7059 14.6167 11.2833L17.1167 8.78335C17.8757 7.9975 18.2957 6.94499 18.2862 5.85251C18.2767 4.76002 17.8385 3.71497 17.066 2.94243C16.2934 2.1699 15.2484 1.7317 14.1559 1.7222C13.0634 1.71271 12.0109 2.13269 11.2251 2.89168L9.79174 4.31668"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6667 9.16665C11.3089 8.68821 10.8523 8.29233 10.3279 8.00587C9.80362 7.7194 9.22382 7.54905 8.62787 7.50637C8.03191 7.46369 7.43375 7.54968 6.87395 7.7585C6.31415 7.96732 5.80581 8.29409 5.38341 8.71665L2.88341 11.2167C2.12442 12.0025 1.70444 13.055 1.71393 14.1475C1.72343 15.24 2.16163 16.285 2.93416 17.0576C3.7067 17.8301 4.75175 18.2683 5.84424 18.2778C6.93672 18.2873 7.98923 17.8673 8.77507 17.1083L10.2001 15.6833"
                stroke="currentColor"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
